import { render, staticRenderFns } from "./help4.vue?vue&type=template&id=6f5fa943&scoped=true"
import script from "./help4.vue?vue&type=script&lang=js"
export * from "./help4.vue?vue&type=script&lang=js"
import style0 from "./help4.vue?vue&type=style&index=0&id=6f5fa943&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5fa943",
  null
  
)

export default component.exports